<template>
  <div>
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{
            $t(
              isNew
                ? "CRUD.newInfo"
                : savable
                ? "CRUD.editInfo"
                : "CRUD.viewInfo",
              [$t("OrderCycles.ObjectName")]
            )
          }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $emit('mode', null);
                  $emit('input', null);
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("OrderCycles.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <v-container>
            <ValidationObserver ref="observer">
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("OrderCycles.Fields.name") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('OrderCycles.Fields.name')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="order_cycle.name"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'name')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ order_cycle.name }}
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("OrderCycles.Fields.detail") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-radio-group row v-model="order_cycle.cycle_type">
                    <v-radio
                      v-for="type in cycleType"
                      :key="type.value"
                      :label="`${type.text}`"
                      :value="type.value"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  <v-chip color="primary" small label>
                    {{ order_cycle.cycle_type | orderCycleTypeText }}
                  </v-chip>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("OrderCycles.Fields.cycle_setting") + $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <div v-if="order_cycle.cycle_type == 0">
                    <v-checkbox
                      v-for="week in weekSetting"
                      v-model="cycle_day_value"
                      :key="week.value"
                      :label="`${week.text}`"
                      :value="week.value"
                    ></v-checkbox>
                  </div>
                  <div
                    v-else-if="
                      order_cycle.cycle_type == 1 &&
                      settings &&
                      !settings.multi_time_period_flg
                    "
                  >
                    <v-row v-for="week in weekSetting" :key="week.value">
                      <v-col>
                        <v-checkbox
                          v-model="cycle_day_value"
                          :label="`${week.text}`"
                          :value="week.value"
                        ></v-checkbox>
                      </v-col>
                      <v-col>
                        <DatetimeRangePicker
                          v-model="cycle_time_value[week.value]"
                          type="minutes"
                        >
                          <template v-slot:header>
                            <v-row
                              no-gutters
                              align="center"
                              style="margin: 5px auto"
                              class="my-2"
                            >
                              <v-col style="text-align: center">
                                {{ $t("OrderCycles.start_time") }}
                              </v-col>
                              <v-divider vertical />
                              <v-col style="text-align: center">
                                {{ $t("OrderCycles.end_time") }}
                              </v-col>
                            </v-row>
                            <v-divider />
                          </template>
                        </DatetimeRangePicker>
                      </v-col>
                    </v-row>
                  </div>
                  <!-- 多时段 -->
                  <div
                    v-else-if="
                      order_cycle.cycle_type == 1 &&
                      settings &&
                      settings.multi_time_period_flg
                    "
                  >
                    <v-row v-for="week in weekSetting" :key="week.value">
                      <v-col cols="4">
                        <v-checkbox
                          v-model="cycle_day_value"
                          :label="`${week.text}`"
                          :value="week.value"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="8">
                        <span
                          v-for="(period, i) in multi_time_period[week.value]"
                          :key="i"
                        >
                          <v-row align="center">
                            <v-col cols="5">
                              <DatetimeRangePicker
                                v-model="period.time"
                                type="minutes"
                              >
                                <template v-slot:header>
                                  <v-row
                                    no-gutters
                                    align="center"
                                    style="margin: 5px auto"
                                    class="my-2"
                                  >
                                    <v-col style="text-align: center">
                                      {{ $t("OrderCycles.start_time") }}
                                    </v-col>
                                    <v-divider vertical />
                                    <v-col style="text-align: center">
                                      {{ $t("OrderCycles.end_time") }}
                                    </v-col>
                                  </v-row>
                                  <v-divider />
                                </template>
                              </DatetimeRangePicker>
                            </v-col>
                            <v-col cols="5">
                              <v-text-field
                                v-model="
                                  period.distribution_default_receive_date
                                "
                                :suffix="$t('OrderCycles.day')"
                                :label="
                                  $t(
                                    'OrderCycles.distribution_default_receive_date'
                                  )
                                "
                                @blur="
                                  period.distribution_default_receive_date =
                                    period.distribution_default_receive_date <
                                    0
                                      ? 0
                                      : $numberFormatter.formatNoDot(
                                          period.distribution_default_receive_date
                                        )
                                "
                                type="number"
                                style="max-width: 150px"
                              >
                              </v-text-field>
                            </v-col>
                            <v-col cols="2">
                              <v-btn
                                x-small
                                color="error"
                                class="ms-1"
                                @click.stop="
                                  removePeriod(Number(week.value), i)
                                "
                                v-if="
                                  i < multi_time_period[week.value].length - 1
                                "
                              >
                                <v-icon x-small class="pe-1">fa-minus</v-icon>
                              </v-btn>
                              <v-btn
                                x-small
                                color="primary"
                                class="ms-1"
                                @click.stop="addPeriod(Number(week.value))"
                                v-if="
                                  i == multi_time_period[week.value].length - 1
                                "
                              >
                                <v-icon x-small class="pe-1">fa-plus</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </span>
                      </v-col>
                    </v-row>
                  </div>
                  <!-- <div v-else-if="order_cycle.cycle_type == 2">
                    <v-checkbox
                      v-for="day in daySetting"
                      v-model="cycle_day_value"
                      :key="day.value"
                      :label="`${day.text}`"
                      :value="day.value"
                    ></v-checkbox>
                  </div>
                  <div v-else-if="order_cycle.cycle_type == 3">
                    <v-row v-for="day in daySetting" :key="day.value">
                      <v-col>
                        <v-checkbox
                          v-model="cycle_day_value"
                          :label="`${day.text}`"
                          :value="day.value"
                        ></v-checkbox>
                      </v-col>
                      <v-col>
                        <DatetimeRangePicker
                          v-model="cycle_time_value[day.value]"
                          type="minutes"
                        />
                      </v-col>
                    </v-row>
                  </div> -->
                </v-col>
                <v-col cols="9" md="7" v-else>
                  <span v-if="order_cycle.cycle_type == 0">
                    <v-chip
                      color="primary mr-2"
                      small
                      label
                      v-for="day in order_cycle.cycle_value"
                      :key="day"
                    >
                      {{ day | orderCycleWeekSettingText }}
                    </v-chip>
                  </span>
                  <div
                    v-else-if="
                      order_cycle.cycle_type == 1 &&
                      settings &&
                      !settings.multi_time_period_flg
                    "
                  >
                    <v-row
                      v-for="day in order_cycle.cycle_value"
                      :key="day.day"
                    >
                      <v-col>
                        <v-chip color="primary mr-2" small label>
                          {{ day.day | orderCycleWeekSettingText }}
                        </v-chip>
                        {{ day.time_start }} ~ {{ day.time_end }}
                      </v-col>
                    </v-row>
                  </div>
                  <div
                    v-else-if="
                      order_cycle.cycle_type == 1 &&
                      settings &&
                      settings.multi_time_period_flg
                    "
                  >
                    <v-row
                      v-for="day in order_cycle.cycle_value"
                      :key="day.day"
                    >
                      <v-col>
                        <v-chip color="primary mr-2" small label>
                          {{ day.day | orderCycleWeekSettingText }}
                        </v-chip>
                      </v-col>
                      <v-col>
                        <div
                          v-for="(period, i) in day.multi_time_period"
                          :key="i"
                          class="mb-1"
                        >
                          {{ period.time_start }} ~ {{ period.time_end }}
                          <span class="pl-2">
                            {{
                              $t(
                                "OrderCycles.distribution_default_receive_date"
                              )
                            }}{{ $t("Global.colon") }}
                            {{ period.distribution_default_receive_date
                            }}{{ $t("OrderCycles.day") }}
                          </span>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="secondary"
                  class="elevation-1"
                  block
                  @click="
                    $emit('input', null);
                    $emit('mode', null);
                  "
                >
                  <v-icon small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.backToList", [$t("OrderCycles.ObjectName")]) }}
                </v-btn>
              </v-col>
              <v-col cols="12" v-if="isView">
                <v-btn
                  color="accent"
                  block
                  :disabled="loading && !order_cycle.id"
                  @click="$emit('mode', 'edit')"
                >
                  <v-icon small class="pe-1">fa-pencil-alt</v-icon>
                  {{ $t("CRUD.editInfo", [$t("OrderCycles.ObjectName")]) }}
                </v-btn>
              </v-col>
              <v-col cols="12" v-if="savable">
                <v-btn
                  color="success"
                  block
                  :disabled="loading && !order_cycle.id"
                  @click="submit()"
                >
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{ $t("CRUD.saveInfo", [$t("OrderCycles.ObjectName")]) }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Required from "@/components/plugins/Required";
import Consts from "@/consts.js";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import DatetimeRangePicker from "@/plugins/datepicker/DatetimeRangePicker";
import OrderCycles from "@/api/order_cycles";

export default {
  name: "OrderCycleDetail",

  props: ["value", "mode"],

  components: {
    Required,
    ValidationObserver,
    ValidationProvider,
    DatetimeRangePicker,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new";
    },
    isNew() {
      return this.mode == "new";
    },
    cycleType() {
      return Consts.orderCycle.type;
    },
    daySetting() {
      return Consts.orderCycle.day;
    },
    weekSetting() {
      return Consts.orderCycle.week;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    order_cycle: {},
    serverErrors: [],
    cycle_day_value: [],
    cycle_time_value: {
      0: ["00:00", "23:59"],
      1: ["00:00", "23:59"],
      2: ["00:00", "23:59"],
      3: ["00:00", "23:59"],
      4: ["00:00", "23:59"],
      5: ["00:00", "23:59"],
      6: ["00:00", "23:59"],
    },
    multi_time_period: {
      0: [{ time: ["00:00", "23:59"], distribution_default_receive_date: 0 }],
      1: [{ time: ["00:00", "23:59"], distribution_default_receive_date: 0 }],
      2: [{ time: ["00:00", "23:59"], distribution_default_receive_date: 0 }],
      3: [{ time: ["00:00", "23:59"], distribution_default_receive_date: 0 }],
      4: [{ time: ["00:00", "23:59"], distribution_default_receive_date: 0 }],
      5: [{ time: ["00:00", "23:59"], distribution_default_receive_date: 0 }],
      6: [{ time: ["00:00", "23:59"], distribution_default_receive_date: 0 }],
    },
  }),

  methods: {
    submit() {
      this.$store.dispatch("fullscreenLoading");
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            if (this.cycle_day_value.length) {
              var cycle_value = [];
              for (let value of this.cycle_day_value) {
                if (this.order_cycle.cycle_type == 0) {
                  cycle_value.push(value);
                } else if (
                  this.order_cycle.cycle_type == 1 &&
                  this.settings &&
                  !this.settings.multi_time_period_flg
                ) {
                  cycle_value.push({
                    day: value,
                    time_start: this.cycle_time_value[value][0],
                    time_end: this.cycle_time_value[value][1],
                  });
                } else if (
                  this.order_cycle.cycle_type == 1 &&
                  this.settings &&
                  this.settings.multi_time_period_flg
                ) {
                  cycle_value.push({
                    day: value,
                    multi_time_period: this.multi_time_period[value].map(
                      (period) => {
                        return {
                          time_start: period.time[0],
                          time_end: period.time[1],
                          distribution_default_receive_date:
                            period.distribution_default_receive_date,
                        };
                      }
                    ),
                  });
                }
              }
              this.order_cycle.cycle_value = JSON.parse(
                JSON.stringify(cycle_value)
              );
              OrderCycles.save(this.order_cycle.id, this.order_cycle)
                .then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.$emit("save", this.order_cycle);
                      this.$emit("mode", null);
                      this.$emit("input", null);
                      this.$refs.observer.reset();
                      this.$store.dispatch("fullscreenLoadingStop");
                    } else if (
                      response.data.error &&
                      response.data.error.data &&
                      "ERR333" == response.data.error.code
                    ) {
                      this.$store.dispatch("fullscreenLoadingStop");
                      this.serverErrors = response.data.error.data;
                    }
                  }.bind(this)
                )
                .catch(
                  function () {
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                );
              this.$store.dispatch("fullscreenLoadingStop");
            } else {
              this.$store.dispatch("fullscreenLoadingStop");
            }
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    addPeriod(day) {
      this.multi_time_period[day].push({
        time: ["00:00", "23:59"],
        distribution_default_receive_date: 0,
      });
    },
    removePeriod(day, index) {
      this.multi_time_period[day].splice(index, 1);
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.serverErrors = []; //重置远端错误提示
        if (this.value && this.value.id) {
          //下单周期详情
          OrderCycles.fetchOne(this.value.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.order_cycle = response.data.order_cycle;
                if (
                  this.order_cycle.cycle_type == 1 &&
                  this.settings &&
                  !this.settings.multi_time_period_flg
                ) {
                  this.order_cycle.cycle_value.map((value) => {
                    this.cycle_day_value.push(Number(value.day));
                    this.cycle_time_value[Number(value.day)] = [
                      value.time_start,
                      value.time_end,
                    ];
                  });
                } else if (
                  this.order_cycle.cycle_type == 1 &&
                  this.settings &&
                  this.settings.multi_time_period_flg
                ) {
                  // 多时段
                  this.order_cycle.cycle_value.forEach((value) => {
                    this.cycle_day_value.push(Number(value.day));
                    this.multi_time_period[Number(value.day)] = [];
                    value.multi_time_period.forEach((period) => {
                      this.multi_time_period[Number(value.day)].push({
                        time: [period.time_start, period.time_end],
                        distribution_default_receive_date:
                          period.distribution_default_receive_date
                            ? period.distribution_default_receive_date
                            : 0,
                      });
                    });
                  });
                } else {
                  this.order_cycle.cycle_value.map((value) => {
                    this.cycle_day_value.push(Number(value));
                  });
                }
              }
            }.bind(this)
          );
        } else {
          // 新建下单周期，初始化默认值
          this.order_cycle = {
            cycle_type: 0,
          };
          this.cycle_day_value = [];
          this.cycle_time_value = {
            0: ["00:00", "23:59"],
            1: ["00:00", "23:59"],
            2: ["00:00", "23:59"],
            3: ["00:00", "23:59"],
            4: ["00:00", "23:59"],
            5: ["00:00", "23:59"],
            6: ["00:00", "23:59"],
          };
          this.multi_time_period = {
            0: [
              {
                time: ["00:00", "23:59"],
                distribution_default_receive_date: 0,
              },
            ],
            1: [
              {
                time: ["00:00", "23:59"],
                distribution_default_receive_date: 0,
              },
            ],
            2: [
              {
                time: ["00:00", "23:59"],
                distribution_default_receive_date: 0,
              },
            ],
            3: [
              {
                time: ["00:00", "23:59"],
                distribution_default_receive_date: 0,
              },
            ],
            4: [
              {
                time: ["00:00", "23:59"],
                distribution_default_receive_date: 0,
              },
            ],
            5: [
              {
                time: ["00:00", "23:59"],
                distribution_default_receive_date: 0,
              },
            ],
            6: [
              {
                time: ["00:00", "23:59"],
                distribution_default_receive_date: 0,
              },
            ],
          };
        }
        this.$scrollTop(); //返回顶部
      },
    },
  },
};
</script>